module.exports = __webpack_public_path__ + "static/media/Rear Right Tire.166a5d37.svg";